import { render, staticRenderFns } from "./Complain.vue?vue&type=template&id=0ce446de&scoped=true&"
import script from "./Complain.vue?vue&type=script&lang=js&"
export * from "./Complain.vue?vue&type=script&lang=js&"
import style0 from "./Complain.vue?vue&type=style&index=0&id=0ce446de&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce446de",
  null
  
)

export default component.exports